import React, { forwardRef } from 'react';
import PropTypes from 'prop-types';
import LayoutStyles from './layoutStyles';

const Layout = props => {
  return <LayoutStyles>{props.children}</LayoutStyles>;
};

Layout.propTypes = {
  children: PropTypes.node,
};

const LayoutMain = forwardRef((props, ref) => {
  return (
    <LayoutStyles.MainStyles ref={ref} {...props}>
      {props.children}
    </LayoutStyles.MainStyles>
  );
});

LayoutMain.propTypes = {
  children: PropTypes.node,
};

const LayoutHeader = props => {
  return (
    <LayoutStyles.HeaderStyles className={props.className}>
      {props.children}
    </LayoutStyles.HeaderStyles>
  );
};

LayoutHeader.propTypes = {
  children: PropTypes.node,
};

const LayoutFooter = props => {
  return (
    <LayoutStyles.FooterStyles className={props.className}>
      {props.children}
    </LayoutStyles.FooterStyles>
  );
};

LayoutFooter.propTypes = {
  children: PropTypes.node,
};

const LayoutHeaderTitle = props => {
  return (
    <LayoutStyles.HeaderTitleStyles {...props}>{props.children}</LayoutStyles.HeaderTitleStyles>
  );
};

LayoutHeaderTitle.propTypes = {
  children: PropTypes.node,
};

const LayoutHeaderLeft = props => {
  return <LayoutStyles.HeaderLeftStyles>{props.children}</LayoutStyles.HeaderLeftStyles>;
};

LayoutHeaderLeft.propTypes = {
  children: PropTypes.node,
};

const LayoutHeaderRight = props => {
  return <LayoutStyles.HeaderRightStyles>{props.children}</LayoutStyles.HeaderRightStyles>;
};

LayoutHeaderRight.propTypes = {
  children: PropTypes.node,
};

const LayoutContainer = props => {
  return <LayoutStyles.ContainerStyles {...props}>{props.children}</LayoutStyles.ContainerStyles>;
};

LayoutContainer.propTypes = {
  children: PropTypes.node,
};

const LayoutAside = props => {
  return <LayoutStyles.AsideStyles>{props.children}</LayoutStyles.AsideStyles>;
};

LayoutAside.propTypes = {
  children: PropTypes.node,
};

const LayoutContent = props => {
  return <LayoutStyles.ContentStyles {...props}>{props.children}</LayoutStyles.ContentStyles>;
};

LayoutContent.propTypes = {
  children: PropTypes.node,
};

Layout.Main = LayoutMain;
Layout.Header = LayoutHeader;
Layout.Footer = LayoutFooter;
Layout.HeaderTitle = LayoutHeaderTitle;
Layout.HeaderLeft = LayoutHeaderLeft;
Layout.HeaderRight = LayoutHeaderRight;
Layout.Container = LayoutContainer;
Layout.Aside = LayoutAside;
Layout.Content = LayoutContent;

export default Layout;
